import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_CASE_CLAIM_DETAILS = "GET_CASE_CLAIM_DETAILS";

export const service = async (data) => {
  if (data?.isManualCase) {
    const options: object = {
      url: "/Api/EaCaseApiController/GetCaseDetail/" + data?.eaCaseId + "/true",
    };
    const response = callMvcApi(options);
    return response;
  } else {
    const options: object = {
      url: "/Api/Case/GetCompleteAuditCaseDetails/",
      method: "POST",
      body: JSON.stringify(data),
      ...getDefaultOptions(),
    };
    const response = callMvcApi(options);
    return response;
  }
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CASE_CLAIM_DETAILS, service, mock);
